import React from 'react';
import PropTypes from 'prop-types';

const Modal = ({ children }) => (
  <div className="modal align-items-center justify-content-center">
    <div className="modal-dialog bg-white border-radius-5px border relative width-100 lp-border">
      <div className="modal-content text-center d-flex align-items-center flex-column padding-top-30px padding-bottom-30px padding-left-15px padding-right-15px padding-left-md-35px padding-right-md-35px">
        {children}
      </div>
    </div>
  </div>
);

Modal.propTypes = { children: PropTypes.node.isRequired };

export default Modal;
